import { ADICIONAR_FILTRO_ITINERARIO } from '../types'

export default function adicionarFiltroItinerario (filtro) {
  return {
    type: ADICIONAR_FILTRO_ITINERARIO,
    payload: filtro
  }
}
